var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0814 21.358C9.71586 21.358 7.49211 20.4363 5.81886 18.7638C4.14561 17.0913 3.22461 14.8668 3.22461 12.5013C3.22461 10.1358 4.14636 7.91053 5.81886 6.23728C7.49136 4.56403 9.71586 3.64453 12.0814 3.64453C14.4469 3.64453 16.6721 4.56478 18.3439 6.23728C20.0164 7.90978 20.9381 10.135 20.9381 12.5013C20.9381 14.8675 20.0179 17.0905 18.3454 18.7638C16.6729 20.437 14.4469 21.358 12.0814 21.358ZM12.0814 5.14453C10.1171 5.14453 8.26986 5.90953 6.87936 7.29778C5.48961 8.68828 4.72461 10.5355 4.72461 12.5013C4.72461 14.4655 5.48961 16.3143 6.87936 17.7033C8.26836 19.0938 10.1164 19.858 12.0814 19.858C14.0471 19.858 15.8944 19.093 17.2849 17.7033C20.1529 14.8353 20.1529 10.168 17.2834 7.29853C15.8944 5.90953 14.0471 5.14453 12.0814 5.14453Z",
    fill: "#25487D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8538 11.6719H7.30859V13.3226H16.8538V11.6719Z",
    fill: "#25487D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.b62c3e13f90195055ea01fa20beb89ed.svg";
export { ForwardRef as ReactComponent };